/**
 * @generated SignedSource<<558e21b46c4a1417a03ab983fa2b1705>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserLanguage = "AR" | "DE" | "EN" | "ES" | "FR" | "IT" | "PL" | "TR";
export type UpdateBusinessUserInput = {
  aml?: ReadonlyArray<UserAML> | null | undefined;
  cookiePreferences?: CookiePreferencesInput | null | undefined;
  email?: string | null | undefined;
  language?: UserLanguage | null | undefined;
  risk?: ReadonlyArray<BusinessUserRisks> | null | undefined;
  termsAndConditions?: ReadonlyArray<string> | null | undefined;
};
export type UserAML = {
  answerId: string;
  questionId: string;
  value?: string | null | undefined;
};
export type BusinessUserRisks = {
  answerId: string;
  questionId: string;
};
export type CookiePreferencesInput = {
  marketing: boolean;
  performance: boolean;
};
export type UpdateBusinessUserMutation$variables = {
  input?: UpdateBusinessUserInput | null | undefined;
};
export type UpdateBusinessUserMutation$data = {
  readonly updateBusinessUser: {
    readonly active?: boolean;
    readonly approved?: boolean;
    readonly cookiePreferences: {
      readonly functional: boolean;
      readonly marketing: boolean;
      readonly performance: boolean;
    };
    readonly id: string;
    readonly language: UserLanguage;
    readonly onboarded: boolean;
    readonly tradingActive?: boolean;
    readonly withdrawalsActive: boolean;
  } | null | undefined;
};
export type UpdateBusinessUserMutation = {
  response: UpdateBusinessUserMutation$data;
  variables: UpdateBusinessUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onboarded",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "withdrawalsActive",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "CookiePreferences",
  "kind": "LinkedField",
  "name": "cookiePreferences",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "marketing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "functional",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "performance",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tradingActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "approved",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    }
  ],
  "type": "BusinessUser",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateBusinessUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateBusinessUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateBusinessUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateBusinessUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9a5eb099d0a42eb523248a54c50ee1ae",
    "id": null,
    "metadata": {},
    "name": "UpdateBusinessUserMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateBusinessUserMutation(\n  $input: UpdateBusinessUserInput\n) {\n  updateBusinessUser(input: $input) {\n    __typename\n    id\n    onboarded\n    language\n    withdrawalsActive\n    cookiePreferences {\n      marketing\n      functional\n      performance\n    }\n    ... on BusinessUser {\n      tradingActive\n      approved\n      active\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "584174c34100b7d1372de2addd93d086";

export default node;
